<template>
  <v-app>
    <!-- 상단 AppBar -->
    <v-app-bar color="black" class="app-bar-title">
      <v-row no-gutters align="center" class="px-4" style="width: 100%">
        <!-- 모바일에서 햄버거 버튼(우측) -->
        <!-- d-none d-md-flex: 데스크톱에서만 보이도록 처리하기 위해 숨김/표시 클래스 사용 -->
        <!-- d-md-none: 모바일 사이즈에서만 보이도록 처리 -->
        <v-btn icon class="d-md-none" @click.stop="drawer = !drawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

        <!-- 가운데 라운드 텍스트 표시 -->
        <v-col cols="auto" class="mx-auto text-h6 fw-bold">
          {{ roundTitle }}
        </v-col>

        <v-spacer />

        <!-- 데스크톱 화면에서만 보이는 버튼들 -->
        <v-col cols="auto" class="d-none d-md-flex">
          <v-btn text class="app-bar-tab" @click="goHome">홈으로</v-btn>
          <v-btn text class="app-bar-tab" @click="goInfo">소개</v-btn>
          <v-btn text class="app-bar-tab" @click="goArtist"
            >최악의 예술가 유형 월드컵</v-btn
          >
          <v-btn text class="app-bar-tab" @click="goTech"
            >최악의 기술자 유형 월드컵</v-btn
          >
          <v-btn text class="app-bar-tab" @click="goStats">월드컵 결과</v-btn>
        </v-col>
      </v-row>
    </v-app-bar>

    <!-- 사이드 메뉴(내비게이션 드로어) -->
    <!-- 모바일에서만 쓰기 때문에 temporary로 선언 -->
    <v-navigation-drawer v-model="drawer" app temporary right color="black">
      <v-list>
        <v-list-item
          @click="
            goHome();
            drawer = false;
          "
        >
          <v-list-item-title>홈으로</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="
            goInfo();
            drawer = false;
          "
        >
          <v-list-item-title>소개</v-list-item-title>
        </v-list-item>

        <v-list-item
          @click="
            goArtist();
            drawer = false;
          "
        >
          <v-list-item-title>최악의 예술가 유형 월드컵</v-list-item-title>
        </v-list-item>

        <v-list-item
          @click="
            goTech();
            drawer = false;
          "
        >
          <v-list-item-title>최악의 기술자 유형 월드컵</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="
            goStats();
            drawer = false;
          "
        >
          <v-list-item-title>월드컵 결과</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- 메인 콘텐츠 -->
    <v-main>
      <!-- 자식 라우트에서 'update-round-title' 이벤트를 받을 때 updateRoundTitle 메서드 실행 -->
      <router-view @update-round-title="updateRoundTitle"></router-view>
    </v-main>

    <!-- 하단 푸터 -->
    <v-footer color="black" height="60" class="pa-2">
      <v-row no-gutters>
        <v-col cols="12" class="text-right white--text">
          © 2025 Joonhyung Bae. All rights reserved.
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "App",
  setup() {
    const router = useRouter();

    // 자식이 보낸 라운드 텍스트를 저장할 변수
    const roundTitle = ref("");

    // 자식 컴포넌트(ArtistCup)에서 @update-round-title="updateRoundTitle"가 호출되면
    // 여기서 받은 newTitle을 roundTitle에 저장 → AppBar에서 표시
    const updateRoundTitle = (newTitle) => {
      roundTitle.value = newTitle;
    };

    // 네비게이션 메뉴 열고 닫기 제어
    const drawer = ref(false);

    // 예시 네비게이션 메서드들
    const goHome = () => router.push("/");
    const goInfo = () => router.push("/info");
    const goArtist = () => router.push("/survey/ArtistCup");
    const goTech = () => router.push("/survey/EngineerCup");
    const goStats = () => router.push("/stats");

    return {
      roundTitle,
      updateRoundTitle,
      drawer,
      goHome,
      goInfo,
      goArtist,
      goTech,
      goStats,
    };
  },
};
</script>

<style>
/* (1) 전역으로 적용할 요소에 폰트 지정 */
html,
body,
.v-application {
  margin: 0;
  padding: 0;
  font-family: "Orbit", sans-serif !important;
  font-weight: 400; /* regular */
  color: #fff;
  background-color: #000;
}

.text-h3 {
  font-family: "Orbit", sans-serif !important;
}

/* (2) 추가 커스텀 스타일(선택 사항) */
.app-bar-title {
  box-shadow: none !important;
}

.app-bar-tab {
  font-size: 1rem;
  margin-left: 8px;
  margin-right: 8px;
  color: #ffffff;
}
</style>
